import React from "react";

const ShippingAndDelivery = () => (
  <div className="max-w-4xl mx-auto p-6 font-sans">
    <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">Shipping & Delivery Policy</h1>
    
    <div className="space-y-6">
      <p className="text-gray-700 leading-relaxed">
        At <strong>JR Home Foods</strong>, we are committed to delivering freshly prepared home-made meals to your doorstep on time and in excellent condition. Please review our delivery terms below.
      </p>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">1. Delivery Coverage</h2>
        <p className="text-gray-700">
          We currently deliver to selected areas within our serviceable zones. During subscription checkout, 
          users must confirm whether their address falls under our delivery areas.
        </p>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">2. Delivery Schedule</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Deliveries are made <strong>daily</strong> as per the subscription plan.</li>
          <li>Customers can choose between available time slots (e.g., <strong>Morning</strong> or <strong>Evening</strong>) during checkout.</li>
          <li>Delivery time windows are approximate but we strive for timely delivery each day.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">3. Delivery Process</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>Meals are freshly prepared each day and dispatched by our delivery team.</li>
          <li>Please ensure someone is available at the delivery address during the selected slot to receive the meal.</li>
          <li>If unattended, we will attempt to contact the registered phone number once.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">4. Missed Deliveries</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>If the delivery fails due to unavailability or incorrect address, the day's meal will be marked as <strong>skipped</strong> and will not be resent.</li>
          <li>Repeated missed deliveries may lead to temporary suspension of service until the issue is resolved.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">5. Rescheduling Deliveries</h2>
        <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
          <li>If you need to pause or reschedule delivery (e.g., due to travel), please use the <strong>"My Plans"</strong> section or notify us at least <strong>24 hours in advance</strong>.</li>
          <li>Rescheduling is subject to plan flexibility and our service policy.</li>
        </ul>
      </div>

      <div className="border-l-4 border-green-500 pl-4">
        <h2 className="text-xl font-bold text-green-700 mb-3">6. Delivery Charges</h2>
        <p className="text-gray-700">
          All delivery charges (if any) are included in the subscription plan pricing unless otherwise specified.
        </p>
      </div>

      <div className="bg-green-50 p-6 rounded-lg mt-8">
        <h3 className="text-lg font-bold text-green-700 mb-3">📞 Need Help?</h3>
        <p className="text-gray-700 mb-3">
          For delivery-related queries or to report issues, please contact us:
        </p>
        <div className="space-y-1 text-gray-700">
          <p>📧 Email: help.jrhomefoods@gmail.com</p>
          <p>📞 Phone: 7893816225</p>
        </div>
      </div>
    </div>
  </div>
);

export default ShippingAndDelivery; 